import { RouteConfig } from "vue-router"

export const routes: RouteConfig[] = [
  {
    path: "/",
    component: () => import("../pages/Home.vue"),
  },
  {
    path: "/booking/:referenceId",
    component: () => import("../pages/BookingWebview.vue"),
  },
  {
    path: "/facility/:id/expired-reservation",
    name: "expired-reservation",
    component: () => import("../pages/ExpiredReservationPage.vue"),
  },
  {
    path: "/not-found",
    name: "not-found",
    component: () => import("../pages/NotFoundPage.vue"),
  },

  {
    path: "/terms",
    name: "terms-page",
    component: () => import("../pages/terms/TermsPage.vue"),
  },

  { path: "*", redirect: "/" },
]
